import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTariffLineItem extends Layout {
    labelTLI: Label;
    panelTariffLineItemTask: Panel;
    sourceTariffLineItem: DataSource;
    tableTariffLineItem: Table;
}
